import React from 'react';
import { observer } from 'mobx-react';
import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Panel from '../../commons/Panel';
import Candidatos from './Candidatos';
import EvolucaoDialog from '../../commons/EvolucaoDialog';

import EvolucaoStore from '../../../stores/EvolucaoStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Distribuicao extends React.Component {
  state = { vagas: 0 };

  componentWillMount() {
    UIStore.init(
      'Projeção de Distribuição de Vagas',
      null,
      null,
      false,
      SelecaoStore.loadColigacoes
    );
    SelecaoStore.loadColigacoes();
  }

  render() {
    let coligacoes = SelecaoStore.coligacoes;
    return (
      <React.Fragment>
        <Panel
          title="Distribuição de Vagas"
          loadHistory={() => EvolucaoStore.loadColigacoes()}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Coligação</TableCell>
                <TableCell numeric>Total Votos</TableCell>
                <TableCell numeric>Vagas Diretas</TableCell>
                <TableCell numeric>Vagas Sobras</TableCell>
                <TableCell numeric>Vagas Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {coligacoes.map(c => (
                <TableRow key={c.id}>
                  <TableCell>
                    <Chip
                      key={c.id}
                      label={c.coligacao.nome}
                      style={{
                        backgroundColor: c.coligacao.cor,
                        fontWeight: 'bold',
                        color: 'white',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        this.setState({
                          vagas: c.vagasDiretas + c.vagasSobras,
                        });
                        SelecaoStore.selecionarCandidatos(c.coligacao);
                      }}
                    />
                  </TableCell>
                  <TableCell numeric>{c.projecao.formatInteger()}</TableCell>
                  <TableCell numeric>{c.vagasDiretas}</TableCell>
                  <TableCell numeric>{c.vagasSobras}</TableCell>
                  <TableCell numeric>
                    {c.vagasDiretas + c.vagasSobras}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Candidatos vagas={this.state.vagas} />
        </Panel>
        <EvolucaoDialog
          title="Evolução das Vagas"
          opened={EvolucaoStore.coligacoes != null}
          data={EvolucaoStore.coligacoes}
          onOK={() => (EvolucaoStore.coligacoes = null)}
        />
      </React.Fragment>
    );
  }
}

export default observer(Distribuicao);



// WEBPACK FOOTER //
// ./src/components/proporcional/distribuicao/index.js